<template>
  <el-dialog
    :title="$t('dialog.titleAssignServiceToRoomServiceGroup')"
    :visible="isShow"
    :close-on-click-modal="false"
    append-to-body
    width="1200px"
    @close="onClose"
  >
    <div class="das-form-container">
      <div class="das-form-group">
        <div class="das-form-row">
          <div class="das-form-col col-3">
            <div class="das-form-input">
              <div class="label">
                {{ $t('field.category') }}
              </div>
              <VxTreeSelect
                :options-tree="categoryOptions"
                :parent-data="searchParams.productPortfolioId"
                @valueChange="onChangeCategory"
              />
            </div>
          </div>
          <div class="das-form-col col-3">
            <div class="das-form-input">
              <div class="label">
                {{ $t('field.productNameOrCode') }}
              </div>
              <input v-model="searchParams.info" type="text" />
            </div>
          </div>
          <div class="das-form-col col-6 flex align-end">
            <div class="das-form-input">
              <div>
                <button class="btn primary small" @click="fnSearch">
                  {{ $t('button.search') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
    </div>

    <div class="das-layout das-form-container">
      <div class="grid-container l-w-50">
        <div class="grid-title">
          {{ $t('views.configuration.unselectedProductAndServiceList') }}
        </div>
        <div style="height: 450px">
          <GridVx
            ref="unselectedServicesGrid"
            v-loading="unselectedServicesGridLoading"
            :auto-select-first-row="false"
            :row-multi-select-with-click="true"
            :columns="unselectedServiceCols"
            :rows="unselectedServiceRows"
            :auto-size-cell="true"
            class="agGrid"
            @selectionChanged="onSelectRowData1"
          />
        </div>
        <div class="grid-bottom">
          <grid-paging-mini
            target="agGrid"
            :total-size="totalUnselectedPage"
            :page-num="currentUnselectedPage"
            @pageChanged="onPageUnselectedChanged"
            @onPageSizeChange="onPageSizeUnselectedChange"
          />
        </div>
      </div>

      <div
        class="l-w-10 flex flex-col transfer-btns-container"
        style="gap: 10px"
      >
        <button
          class="btn only-icon transfer"
          style="margin-bottom: 10px"
          :disabled="disableTransButton1"
          @click="fnSelectService"
        >
          <i class="el-icon-d-arrow-right"></i>
        </button>
        <button
          class="btn only-icon transfer"
          style="margin-bottom: 10px"
          :disabled="disableTransButton2"
          @click="fnUnselectService"
        >
          <i class="el-icon-d-arrow-left"></i>
        </button>
      </div>

      <div class="grid-container l-w-50">
        <div class="grid-title">
          {{ $t('views.configuration.selectedProductAndServiceList') }}
        </div>
        <div style="height: 450px">
          <GridVx
            ref="selectedServicesGrid"
            v-loading="selectedServicesGridLoading"
            :context="context"
            :auto-select-first-row="false"
            :row-multi-select-with-click="true"
            :columns="selectedServiceCols"
            :rows="selectedServiceRows"
            :auto-size-cell="true"
            class="agGrid"
            @selectionChanged="onSelectRowData2"
          />
        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <div class="button-containers flex justify-end" style="gap: 10px">
        <button class="btn primary small outline" @click="onClose">
          {{ $t('button.cancel') }}
        </button>
        <button class="btn primary small" @click="fnSave">
          {{ $t('button.save') }}
        </button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import {
  // eslint-disable-next-line no-unused-vars
  addProductToRoomServiceGroupApi,
  // eslint-disable-next-line no-unused-vars
  getRoomServiceProductListApi,
  // eslint-disable-next-line no-unused-vars
  getRestProductListApi
} from '@/api/Service_Policy/roomServiceGroup'
import { getListProductCategoryApi } from '@/api/configuration/accounting/product/productCategory.js'
import { CellRenderVxCurrencyInput } from '@/utils/cellRenders'
import VxTreeSelect from '@/components/ui/VxTreeSelect.vue'
import GridPagingMini from '@/components/grid/GridPagingMini.vue'

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    CellRenderVxCurrencyInput,
    VxTreeSelect,
    GridPagingMini
  },
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    roomServiceGroupId: {
      type: [String, Number]
    }
  },
  data() {
    return {
      searchParams: {
        pageSize: 10,
        pageNum: 1,
        info: null,
        productPortfolioId: null
      },
      categoryOptions: [],
      unselectedServiceCols: [
        {
          headerdesc: '',
          // field: "index",
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.code'),
          field: 'code',
          // cellClass: "grid-cell-centered",
          minWidth: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.name'),
          field: 'name',
          // cellClass: "grid-cell-centered",
          minWidth: 200,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.commonPrice'),
          field: 'price',
          valueGetter: params => {
            const price = params.data.price
            return price !== null ? price.toLocaleString('en') : ''
          },
          // cellClass: "grid-cell-centered",
          minWidth: 100,
          sortable: false
        }
      ],
      selectedServiceCols: [
        {
          headerdesc: '',
          // field: "index",
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: this.$t('grid.column.code'),
          field: 'code',
          // cellClass: "grid-cell-centered",
          minWidth: 100
        },
        {
          headerName: this.$t('grid.column.name'),
          field: 'name',
          // cellClass: "grid-cell-centered",
          minWidth: 200
        },
        {
          headerName: this.$t('grid.column.unitPrice'),
          field: 'price',
          cellRenderer: 'CellRenderVxCurrencyInput',
          // cellClass: "grid-cell-centered",
          minWidth: 100
        }
      ],
      selectedServiceRows: [],
      unselectedServiceRows: [],
      unselectedServicesGridLoading: false,
      selectedServicesGridLoading: false,
      totalUnselectedPage: 0,
      currentUnselectedPage: 0,
      disableTransButton1: true,
      disableTransButton2: true
    }
  },
  watch: {
    isShow: {
      handler(val) {
        if (val) {
          this.fnGetCategoryList()
          this.attachData()
        } else {
          // RESET SEARCH
          setTimeout(() => {
            this.searchParams = {
              pageSize: 10,
              pageNum: 1,
              info: null,
              productPortfolioId: null
            }
          }, 300)
        }
      },
      immediate: true
    }
  },
  beforeMount() {
    this.context = { componentParent: this }
  },
  methods: {
    onSelectRowData1(rows) {
      this.disableTransButton1 = !rows?.length
    },

    onSelectRowData2(rows) {
      this.disableTransButton2 = !rows?.length
    },
    convertCategoryTree(obj) {
      if (!obj || typeof obj !== 'object') return obj

      if (Array.isArray(obj)) {
        return obj.map(item => this.convertCategoryTree(item))
      }

      const newObj = {}
      for (const key in obj) {
        switch (key) {
          case 'id':
            newObj[key] = obj[key]
            break
          case 'code':
            newObj['label'] = obj[key]
            break
          case 'children':
            if (obj[key]?.length) {
              newObj[key] = this.convertCategoryTree(obj[key])
            }
            break
          default:
            break
        }
      }
      return newObj
    },

    onChangeCategory(data) {
      this.searchParams.productPortfolioId = data
    },

    // GRID
    onPageUnselectedChanged(pageNum) {
      this.searchParams.pageNum = pageNum
      this.fnGetUnselectedServiceList()
    },

    onPageSizeUnselectedChange(pageSize) {
      this.searchParams.pageNum = 1
      this.searchParams.pageSize = pageSize
      this.fnGetUnselectedServiceList()
    },

    onChangeCurrencyInput(params, value, field) {
      const idx = params.rowIndex
      this.selectedServiceRows[idx][field] = value
    },

    fnUnselectService() {
      const rowsSelected =
        this.$refs.selectedServicesGrid.gridApi.getSelectedRows()

      if (!rowsSelected?.length) {
        return
      }

      this.$refs.unselectedServicesGrid.gridApi.applyTransaction({
        add: rowsSelected
      })
      this.$refs.selectedServicesGrid.gridApi.applyTransaction({
        remove: rowsSelected
      })

      this.selectedServiceRows = this.selectedServiceRows?.filter(
        row => !rowsSelected.includes(row)
      )
      this.unselectedServiceRows = [
        ...this.unselectedServiceRows,
        ...rowsSelected
      ]

      this.fnAddSelectedProducts()
    },

    fnSelectService() {
      const rowsSelected =
        this.$refs.unselectedServicesGrid.gridApi.getSelectedRows()

      this.$refs.unselectedServicesGrid.gridApi.applyTransaction({
        remove: rowsSelected
      })
      this.$refs.selectedServicesGrid.gridApi.applyTransaction({
        add: rowsSelected
      })

      this.unselectedServiceRows = this.unselectedServiceRows?.filter(
        row => !rowsSelected.includes(row)
      )
      this.selectedServiceRows = [...this.selectedServiceRows, ...rowsSelected]

      // const idList = [...rowsSelected, ...this.selectedServiceRows].map(
      //   item => item.id
      // )
      // addProductToRoomServiceGroupApi({
      //   id: this.roomServiceGroupId,
      //   payload: idList
      // })
      //   .then(res => {
      //     this.$message({
      //       type: 'success',
      //       message: this.$t('successMsg.' + res.message)
      //     })
      //   })
      //   .catch(err => {
      //     this.$message({
      //       type: 'error',
      //       message: this.$t('errorMsg.' + err.response.data.message)
      //     })
      //   })
      // console.log(rowsSelected)
    },

    // SELECT OPTIONS
    fnGetCategoryList() {
      getListProductCategoryApi().then(res => {
        this.categoryOptions = this.convertCategoryTree(res.data)
      })
    },

    fnGetSelectedServiceList() {
      this.unselectedServicesGridLoading = true

      getRoomServiceProductListApi(this.roomServiceGroupId)
        .then(res => {
          this.selectedServiceRows = res.data
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.unselectedServicesGridLoading = false
        })
    },

    fnGetUnselectedServiceList() {
      this.unselectedServicesGridLoading = true
      getRestProductListApi({
        ...this.searchParams,
        id: this.roomServiceGroupId
      })
        .then(res => {
          this.unselectedServiceRows = res.data
          this.totalUnselectedPage = Math.ceil(
            res.total / this.searchParams.pageSize
          )
          this.currentUnselectedPage =
            res.data.length === 0 ? 0 : this.searchParams.pageNum
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.unselectedServicesGridLoading = false
        })
    },

    /**
     * SEND REQUEST
     */
    async fnAddSelectedProducts() {
      const payload = this.selectedServiceRows.map(item => ({
        id: item.id,
        code: item.code,
        name: item.name,
        price: Number(item.price)
      }))
      await addProductToRoomServiceGroupApi({
        id: this.roomServiceGroupId,
        payload: payload
      })
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + err.response.data.message)
          })
        })
        .finally(() => {
          this.attachData()
        })
    },

    onClose() {
      this.$emit('close')
    },

    fnSearch() {
      this.fnGetUnselectedServiceList()
    },

    async fnSave() {
      this.fnAddSelectedProducts()
    },

    attachData() {
      this.fnGetSelectedServiceList()
      this.fnGetUnselectedServiceList()
    }
  }
}
</script>

<style lang="scss" scoped>
hr {
  border-top: 1px solid #dedfe7;
}
.grid-container {
  // border: 1px solid #dedfe7;
  // border-radius: 5px;
  padding: 15px 0px;

  .grid-title {
    padding-bottom: 10px;
  }
}

.transfer-btns-container {
  position: relative;
  top: 41px;
  height: 100%;

  .btn {
    &.only-icon.transfer {
      background: #357456;
      border-radius: 5px;
      i {
        color: #fff;
      }
    }
  }
}
</style>
